import { map as _map } from 'lodash-es';
import { useEffect } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaptionPlugin from 'photoswipe-dynamic-caption-plugin';
import { makeStyles } from 'tss-react/mui';
import ImageUploadGalleryItem from './image-upload-gallery-item';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import type { ImageUpload } from '../types/ImageUpload';

const useStyles = makeStyles()(() => ({
  gallery: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

type Props = {
  imageUploads?: ImageUpload[];
  galleryId: string;
};

const ImageUploadGallery = ({ imageUploads, galleryId }: Props) => {
  const { classes, cx } = useStyles();

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: `#gallery-${galleryId}`,
      children: '.pswp-gallery__item',
      pswpModule: () => import('photoswipe'),
    });
    new PhotoSwipeDynamicCaptionPlugin(lightbox, {
      type: 'auto',
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, [galleryId]);

  if (!imageUploads.length) {
    return <p>No photos yet!</p>;
  }

  return (
    <div className={cx('pswp-gallery', classes.gallery)} id={`gallery-${galleryId}`}>
      {_map(imageUploads, (imageUpload) => (
        <ImageUploadGalleryItem
          imageUpload={imageUpload}
          key={imageUpload.id}
        />
      ))}
    </div>
  );
};

export default ImageUploadGallery;
